//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Assemblies.js";
import "../no/NXObject.js";
import "../no/PartLoadStatus.js";
let d=[[[0,"NumberOfComponents",0,0]],[[[],"Open",{R_:{load_status:"PartLoadStatus"}},0,0],[["n_components"],"GetComponents",{R_:{components:"Assemblies.Component[]"}},0,0],[["component","and_children"],"AddComponent",{},2,0],[["component"],"RemoveComponent",{},1,0]],[]];
SPLM.Assemblies.ComponentGroup = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Assemblies.ComponentGroup";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;